import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RemoveMemberPayload, RemoveMemberResponse } from '@edtech-ui/core/models/members/delete-member';
import { InviteStudentTeacherPayload, InviteStudentTeacherResponse } from '@edtech-ui/core/models/members/invite-student-teacher';
import { GetMemberResponse } from '@edtech-ui/core/models/members/teacher';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class MemberManagementService {

	apiUrl = environment.memberApiUrl;

	constructor(private http: HttpClient) { }

	getClassroomMembers(classroomId: number): Observable<GetMemberResponse> {
		return this.http.get<GetMemberResponse>(`${this.apiUrl}/getMembers/${classroomId}`);
	}

	getMembers(id: number): Observable<GetMemberResponse> {
		return this.http.get<GetMemberResponse>(`${this.apiUrl}/getMembers/${id}`);
	}

	postInviteStudent(payload: InviteStudentTeacherPayload): Observable<InviteStudentTeacherResponse> {
		return this.http.post<InviteStudentTeacherResponse>(`${this.apiUrl}/inviteStudent`, payload);
	}

	deleteMembers(payload:RemoveMemberPayload):Observable<RemoveMemberResponse>{
		return this.http.delete<RemoveMemberResponse>(`${this.apiUrl}/removeMembers` ,{ body :payload } );
	}

}
